

























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import DateUtils from '@/common/js/DateUtils'
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import EditGroup from './edit-group.vue'
import CreateGroup from './create-group.vue'
class PagegroupRequest extends PageRequest {
    groupName: string;  
}
@Component({
    name: "group",
    components: { EditGroup, CreateGroup}
})
export default class groups extends AbpBase {
   
    editModalShow: boolean = false;
    createModalShow: boolean = false;
    edit() {
        this.editModalShow = true;
    }
    create() {
        this.createModalShow = true;
    }
    //filters
    pagerequest: PagegroupRequest = new PagegroupRequest();
    get list() {
        return this.$store.state.group.list;
    };
    get loading() {
        return this.$store.state.group.loading;
    }
    pageChange(page: number) {
        this.$store.commit('group/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('group/setPageSize', pagesize);
        this.getpage();
    }

    async searchPage() {
        this.$store.state.group.currentPage = 1;
        this.getpage();
    }

    async getpage() {

        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

        await this.$store.dispatch({
            type: 'group/getAll',
            data: this.pagerequest
        })
    }

    get pageSize() {
        return this.$store.state.group.pageSize;
    }
    get totalCount() {
        return this.$store.state.group.totalCount;
    }
    get currentPage() {
        return this.$store.state.group.currentPage;
    }
    columns = [{
        title: '分组名称',
        key: 'groupName'
    }, {
        title: '创建时间',
        key: 'creationTime',
         render: (h: any, params: any) => {
             return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
        }
        },
        {
            title: '修改时间',
            key: 'updateTime',
            render: (h: any, params: any) => {
                return h('span', params.row.updateTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.updateTime)));
            }
        },
        {
            title: this.L('操作'),
            key: 'Actions',
            width: 150,
            render: (h: any, params: any) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.$store.commit('group/edit', params.row);
                                this.edit();
                              
                            }
                        }
                    }, this.L('修改')),
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        on: {
                            click: async () => {
                                this.$Modal.confirm({
                                    title: this.L('Tips'),
                                    content: this.L('DeleteUserConfirm'),
                                    okText: this.L('Yes'),
                                    cancelText: this.L('No'),
                                    onOk: async () => {
                                        await this.$store.dispatch({
                                            type: 'group/deleteGroup',
                                            data: { groupId: params.row.id}
                                        })
                                        await this.getpage();
                                    }
                                })
                            }
                        }
                    }, this.L('删除'))
                ])
            }
        }]
    async created() {
        this.getpage();
        
    }
}
